import React, {
  useEffect,
  useState,
  createContext,
  useContext,
  useRef,
} from "react";
import {
  Box,
  Button,
  Container,
  Typography,
  Paper,
  TextField,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import TextSnippetIcon from "@mui/icons-material/TextSnippet";
import ModeIcon from "@mui/icons-material/Mode";
import DoneIcon from "@mui/icons-material/Done";
import ExampleTestPart1 from "../components/ExampleTestPart1";
import TestPart1 from "../components/TestPart1";
import ExampleTestPart2 from "../components/ExampleTestPart2";
import TestPart2 from "../components/TestPart2";
import ExampleTestPart3 from "../components/ExampleTestPart3";
import TestPart3 from "../components/TestPart3";
import ThanksPage from "../components/ThanksPage";
import { Helmet } from "react-helmet";
import { getQuestionPart, postTopInfo } from "../services/callApi";
import { splitQuestionParts } from "../utils/questionPartData";
import { parseTopInfoResponse } from "../utils/topInfoResponse";

// ローカルなContextを作成
const JsonContext = createContext();

function AptitudeTest() {
  const [company_id, setCompany_id] = useState("1");
  const [lastName, setLastName] = useState("");
  const [firstName, setFirstName] = useState("");
  const [name, setName] = useState("");
  const [lastNameKana, setLastNameKana] = useState("");
  const [firstNameKana, setFirstNameKana] = useState("");
  const [frigana, setFrigana] = useState("");
  const [password, setPassword] = useState("");
  const [agree, setAgree] = useState(false);
  const [progressIndex, setProgressIndex] = useState(0);
  const [isSelect, setIsSelect] = React.useState(false);
  const [jsonData, setJsonData] = useState({});
  const [testData1, setTestData1] = useState({});
  const [testData2, setTestData2] = useState({});
  const [testData3, setTestData3] = useState({});
  const childButtonClickRef = useRef(null);
  const registrationInFlightRef = useRef(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [loading, setLoading] = useState(false);
  const [apiError, setApiError] = useState("");
  const [questionLoadError, setQuestionLoadError] = useState(false);
  const [isMaintenance, setIsMaintenance] = useState(false);

  useEffect(() => {
    setName(`${lastName} ${firstName}`);
    setFrigana(`${lastNameKana} ${firstNameKana}`);
  }, [firstName, lastName, firstNameKana, lastNameKana]);


  const fetchQuestions = async () => {
    try {
      const questions = await getQuestionPart();
      const { part1, part2, part3 } = splitQuestionParts(questions);

      setTestData1(part1);
      setTestData2(part2);
      setTestData3(part3);
    } catch (error) {
      console.error("エラーが発生しました:", error);
      throw error;
    }
  };

  // JSONに値を追加する関数
  const addValueToJson = (key, value, callback) => {
    setJsonData((prev) => {
      const updatedData =
        prev[key] !== undefined
          ? { ...prev, [key]: [...prev[key], ...value] }
          : { ...prev, [key]: value };

      if (callback) {
        callback(updatedData);
      }
      return updatedData;
    });
  };

  // エラーメッセージのstate
  const [errors, setErrors] = useState({
    fullName: "",
    fullNameKana: "",
    password: "",
    agree: "",
  });

  // フォームのバリデーション
  const validateForm = () => {
    const newErrors = {
      fullName: "",
      fullNameKana: "",
      password: "",
      agree: "",
    };

    if (!lastName || !firstName) {
      newErrors.fullName = "氏名を正しく入力してください";
    }

    if (!lastNameKana || !firstNameKana) {
      newErrors.fullNameKana = "ふりがなを正しく入力してください";
    }

    if (!password) {
      newErrors.password = "パスワードを正しく入力してください。";
    }

    if (!agree) {
      newErrors.agree = "[同意します]にチェックを入れてください。";
    }

    setErrors(newErrors);

    // エラーがないか確認
    return !Object.values(newErrors).some((error) => error !== "");
  };

  // フォーム送信時の処理
  const handleSubmit = async (e) => {
    if (registrationInFlightRef.current || isMaintenance) {
      console.log("無効です。");
      setLoading(false);
      return;
    }
    // ボタンを無効化
    setIsButtonDisabled(true);

    if (validateForm()) {
      registrationInFlightRef.current = true;
      setIsButtonDisabled(true);
      // 入力されたデータをJSONに整形
      const requestData = {
        company_id,
        name,
        frigana,
        password,
      };

      try {
        console.log("フォームデータ (JSON):", JSON.stringify(requestData));

        const response = await postTopInfo(requestData);
        console.log("response:" + response);

        const createUserResult = parseTopInfoResponse(response);
        if (!createUserResult.isSuccess) {
          if (createUserResult.reason === "invalid_password") {
            setErrors((current) => ({
              ...current,
              password: "パスワードを正しく入力してください。",
            }));
          } else {
            setApiError("受験者情報の登録に失敗しました。入力内容を確認して再度お試しください。");
          }
          window.scrollTo({ top: 350, behavior: "smooth" });
          setLoading(false);
          setIsButtonDisabled(false);
          return false;
        }

        // 各部の問題を取得する
        await fetchQuestions();

        // // user_idを取り出す （例)"OK: user_id = 3" から 3 を抽出
        const userId = createUserResult.userId;
        console.log("userId:" + userId);
        if (userId) {
          console.log("取得した user_id:", userId);

          // JsonContext へ保存する
          addValueToJson("user_id", userId);
        } else {
          console.error("user_id がレスポンスから見つかりませんでした");
        }
      } catch (error) {
        if (error.response.status === 503) {
          setIsMaintenance(true);
          alert("現在メンテナンス中のため、受験を開始することができません。\n大変申し訳ございませんが、しばらく時間をおいてから再度お試しください。");
          setApiError(
            "現在メンテナンス中のため、受験を開始することができません。\n" +
            "大変申し訳ございませんが、しばらく時間をおいてから再度お試しください。"
          );
          setLoading(false);
          return false;
        }
        console.error("通信エラー:", error);
        setApiError("試験の開始に失敗しました。通信環境を確認して再度お試しください。");
        setLoading(false);
        setIsButtonDisabled(false);
        return false;
      } finally {
        registrationInFlightRef.current = false;
        setIsButtonDisabled(false);
      }
      setLoading(false);
      setIsButtonDisabled(false);
      return true;
    }
    setLoading(false);
    setIsButtonDisabled(false);
    return false;
  };

  // 進行インデックスをインクリメント（次のステップに進む）
  const nextPage = () => {
    setProgressIndex((prevIndex) => prevIndex + 1);
    setIsSelect(true);
  };

  // ページ遷移した際にページトップへスクロール
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [progressIndex]);

  // 次の画面に進む処理
  const nextOnClick = () => {
    if (progressIndex !== 2 && progressIndex !== 4 && progressIndex !== 6) {
      nextPage();
    }
    // 子コンポーネントの 関数 を呼び出す（progressIndexが奇数は例題画面、偶数は試験画面）
    if (progressIndex === 1 || progressIndex === 3 || progressIndex === 5) {
      childButtonClickRef.current.handleButtonClick(); // ここで子コンポーネントの関数が呼ばれる
    } else if (
      progressIndex === 2 ||
      progressIndex === 4 ||
      progressIndex === 6
    ) {
      childButtonClickRef.current.handleOpenDialog();
    }
    setLoading(false);
  };

  return (
    <Container component="main" sx={{padding: { xs: 0}}}>
      <JsonContext.Provider
        value={{ jsonData, addValueToJson }}
      ></JsonContext.Provider>
      <Helmet>
        <title>適性テスト</title>
      </Helmet>
      <Paper
        elevation={3}
        sx={{
          width: { xs: "100%", sm: "95%" },
          padding: { xs: 1, sm: 1, md: 2 },
          marginBottom: 4,
          margin: "0 auto",
          minHeight: '87vh'
        }}
      >
        <Box sx={{ margin: { xs: "1rem 0 2rem", sm: "1rem 0 3rem" }, position: "relative", minHeight: { xs: 120, sm: 160 }, }}>
          {/* 横線（背景） */}
          <Box
            sx={{
              position: "absolute",
              top: { xs: 41, sm: 68 },
              left: "calc((40px + 30px) / 2)", // 左側のマージン補正（例題と非例題考慮）
              right: "calc((40px + 30px) / 2)", // 右も同様
              transform: "translateY(-50%)",
              height: { xs: "5px", sm: "11px" },
              backgroundColor: "#ccc",
              zIndex: 0,
            }}
          />

          {/* 完了済み部分の横線（上に重ねて表示） */}
          <Box
            sx={{
              position: "absolute",
              top: { xs: 41, sm: 68 },
              left: "calc((40px + 30px) / 2)",
              width: `calc(${(progressIndex / 7) * 100}% - ${(progressIndex * 14) / 2}px)`,
              transform: "translateY(-50%)",
              height: { xs: "5px", sm: "11px" },
              backgroundColor: "#1976D2",
              zIndex: 1,
              transition: "width 0.3s ease-in-out",
            }}
          />

          {/* ステップ一覧 */}
          <Box
            component="ul"
            sx={{
              listStyleType: "none",
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              padding: 0,
              margin: 0,
              position: "relative",
              zIndex: 2,
            }}
          >
            {[
              "氏名入力",
              "例題",
              "第1部",
              "例題",
              "第2部",
              "例題",
              "第3部",
              "試験終了",
            ].map((text, index) => {
              const isCompleted = index < progressIndex;
              const isCurrent = index === progressIndex;
              const isExample = text === "例題";

              let IconComponent;
              switch (text) {
                case "氏名入力":
                  IconComponent = PersonIcon;
                  break;
                case "例題":
                  IconComponent = TextSnippetIcon;
                  break;
                case "第1部":
                case "第2部":
                case "第3部":
                  IconComponent = ModeIcon;
                  break;
                case "試験終了":
                  IconComponent = DoneIcon;
                  break;
                default:
                  IconComponent = null;
              }

              const iconSize = {
                xs: isExample ? 25 : 33,
                sm: isExample ? 60 : 73,
              };

              const fontSize = {
                xs: isExample ? 16 : 22,
                sm: isExample ? 24 : 32,
              };

              return (
                <Box
                  component="li"
                  key={index}
                  sx={{
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    position: "relative",
                    minHeight: { xs: 70, sm: 100 }, // 高さを確保してテキストと重ならないようにする
                  }}
                >
                  {/* 丸とアイコン */}
                  <Box
                    sx={{
                      width: iconSize,
                      height: iconSize,
                      borderRadius: "50%",
                      backgroundColor: isCompleted || isCurrent ? "#1976D2" : "#ccc",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      position: "absolute",
                      top: "50%",
                      transform: "translateY(-50%)",
                      zIndex: 3,
                    }}
                  >
                    {IconComponent && (
                      <IconComponent
                        sx={{
                          color: "white",
                          fontSize: fontSize,
                        }}
                      />
                    )}
                  </Box>

                  {/* テキスト */}
                  <Typography
                    sx={{
                      marginTop: { xs: 8, sm: 13 }, // 丸と被らないように下げる
                      fontSize: { xs: "10px", sm: "1rem" },
                      textAlign: "center",
                      whiteSpace: "nowrap",
                      zIndex: 4,
                    }}
                  >
                    {text}
                  </Typography>
                </Box>
              );
            })}
          </Box>
        </Box>
        <Box hidden={isSelect}>
          <Box sx={{ padding: { xs: "1rem", sm: "3rem 2rem 1rem 2rem" } }}>
            <Typography
              align="left"
              sx={{
                fontSize: { xs: "0.9rem", sm: "1.2rem" },
                fontWeight: "bold",
                lineHeight: { xs: "1.5rem", sm: "2rem" },
              }}
            >
              試験は全3部に分かれており、それぞれのページの最初には例題と説明文が書かれています。
              <br />
              試験を始めると
              <span style={{ backgroundColor: "#fcc66a" }}>
                元のページには戻れないので内容を良く理解して試験解答のページへ移動してください。
              </span>
              <br />
              また、ブラウザの”戻る”ボタンは使わないようお願いします。
              <br />
              試験は各部ごとに制限時間が設けられておりますので制限時間内で解答してください。
              <br />
              問題は全て答える必要は無く、分からなければ飛ばして解答していただいても結構です。
              <br />
              第3部は計算問題がございます。
              <br />
              各自、計算用紙をご用意いただきますようお願い致します。
              <br />
              解答がすべて終了しましたら、
              <span style={{ backgroundColor: "#fcc66a" }}>
              必ず最後の「解答終了」ボタンを押してください。
              </span>
              ボタンを押さないと解答が正常に送信されませんのでご注意ください。
            </Typography>
          </Box>
          <Box>
            <form onSubmit={handleSubmit}>
              <Box
                sx={{
                  padding: { xs: "2rem 1rem", sm: "3rem 4rem" },
                  margin: { xs: "1rem", sm: "2rem 2rem 3rem" },
                  border: "solid 1px gray",
                  borderRadius: "10px",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: { xs: "column", sm: "row" },
                    marginBottom: "1rem",
                  }}
                >
                  <Box sx={{ width: { xs: "100%", sm: "50%" } }}>
                    <Typography
                      sx={{
                        fontSize: "1.2rem",
                        fontWeight: "bold",
                        color: "#003d77",
                      }}
                    >
                      氏名（姓）
                    </Typography>
                    <TextField
                      fullWidth
                      variant="outlined"
                      placeholder="山田"
                      value={lastName}
                      onChange={(e) => setLastName(e.target.value)}
                      error={!!errors.fullName}
                      helperText={errors.fullName}
                    />
                  </Box>
                  <Box
                    sx={{
                      width: { xs: "100%", sm: "50%" },
                      marginLeft: { xs: 0, sm: "2rem" },
                      mt: { xs: 2, sm: 0 },
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: "1.2rem",
                        fontWeight: "bold",
                        color: "#003d77",
                      }}
                    >
                      氏名（名）
                    </Typography>
                    <TextField
                      fullWidth
                      variant="outlined"
                      placeholder="太郎"
                      value={firstName}
                      onChange={(e) => setFirstName(e.target.value)}
                      error={!!errors.fullName}
                    />
                  </Box>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: { xs: "column", sm: "row" },
                    marginBottom: "1rem",
                  }}
                >
                  <Box sx={{ width: { xs: "100%", sm: "50%" } }}>
                    <Typography
                      sx={{
                        fontSize: "1.2rem",
                        fontWeight: "bold",
                        color: "#003d77",
                      }}
                    >
                      ふりがな（姓）
                    </Typography>
                    <TextField
                      fullWidth
                      variant="outlined"
                      placeholder="やまだ"
                      value={lastNameKana}
                      onChange={(e) => setLastNameKana(e.target.value)}
                      error={!!errors.fullNameKana}
                      helperText={errors.fullNameKana}
                    />
                  </Box>
                  <Box
                    sx={{
                      width: { xs: "100%", sm: "50%" },
                      marginLeft: { xs: 0, sm: "2rem" },
                      mt: { xs: 2, sm: 0 },
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: "1.2rem",
                        fontWeight: "bold",
                        color: "#003d77",
                      }}
                    >
                      ふりがな（名）
                    </Typography>
                    <TextField
                      fullWidth
                      variant="outlined"
                      placeholder="たろう"
                      value={firstNameKana}
                      onChange={(e) => setFirstNameKana(e.target.value)}
                      error={!!errors.fullNameKana}
                    />
                  </Box>
                </Box>

                <Box>
                  <Typography
                    sx={{
                      fontSize: "1.2rem",
                      fontWeight: "bold",
                      color: "#003d77",
                    }}
                  >
                    パスワード
                  </Typography>
                  <TextField
                    fullWidth
                    type="password"
                    placeholder="パスワードを入力してください"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    error={!!errors.password}
                    helperText={errors.password}
                  />
                </Box>
              </Box>

              <Box sx={{ padding: { xs: "0 1rem", sm: "0 2rem" } }}>
                <Typography
                  variant="h6"
                  gutterBottom
                  sx={{
                    marginBottom: "1rem",
                    fontSize: { xs: "1.2rem", sm: "1.4rem" },
                    fontWeight: "bold",
                    borderBottom: "solid 1px gray",
                  }}
                >
                  個人情報の取り扱いについて
                </Typography>
                <Box
                  sx={{
                    maxHeight: "400px",
                    overflow: "auto",
                    padding: "1rem",
                    border: "1px solid #ccc",
                    borderRadius: "8px",
                    backgroundColor: "#F8F8F8",
                    "& .MuiTypography-root": {
                      fontSize: { xs: "0.9rem", sm: "1.1rem" },
                      paddingBottom: { xs: "1.5rem", sm: "2.5rem" },
                    },
                    "& h4.MuiTypography-root": {
                      fontSize: { xs: "1rem", sm: "1.2rem" },
                      fontWeight: "bold",
                      paddingBottom: "0.4rem",
                    },
                  }}
                >
                  <Typography
                    variant="h4"
                    sx={{
                      paddingBottom: "0.4rem",
                      fontSize: "1.2rem",
                      fontWeight: "bold",
                    }}
                  >
                    1.個人情報
                  </Typography>
                  <Typography
                    sx={{
                      paddingBottom: "2.5rem",
                      fontSize: "1.1rem",
                      color: "#444343",
                    }}
                  >
                    個人情報とは、応募者に関する情報であって、氏名、住所、生年月日、電話番号等、個人を特定できる情報をいいます。
                    <br />
                    機微な個人情報とは、応募者に関する情報であって、学歴及び学業成績及び適性試験や医療情報等、個人の重要な情報を言います。
                    <br />
                    また、その情報のみでは識別できない場合でも、他の情報と容易に照合することができ、結果的に個人を識別できるものも個人情報に含まれます。
                  </Typography>
                  <Typography
                    variant="h4"
                    sx={{
                      paddingBottom: "0.4rem",
                      fontSize: "1.2rem",
                      fontWeight: "bold",
                    }}
                  >
                    2.個人情報の適切な保護と管理者
                  </Typography>
                  <Typography
                    sx={{
                      paddingBottom: "2.5rem",
                      fontSize: "1.1rem",
                      color: "#444343",
                    }}
                  >
                    当社は、次の者を個人情報保護管理責任者として任命し、従業員の個人情報を適切かつ安全に管理し、
                    <br />
                    外部からの個人情報への不正アクセスやその不正使用、紛失、破壊、改ざん及び漏洩等を防止する保護策を講じています。
                    <br />
                    個人情報保護管理責任者　菊池 純
                  </Typography>
                  <Typography
                    variant="h4"
                    sx={{
                      paddingBottom: "0.4rem",
                      fontSize: "1.2rem",
                      fontWeight: "bold",
                    }}
                  >
                    3.個人情報の取得･利用について
                  </Typography>
                  <Typography
                    sx={{
                      paddingBottom: "2.5rem",
                      fontSize: "1.1rem",
                      color: "#444343",
                    }}
                  >
                    当社が応募者から収集した個人情報は、以下の目的に限り使用します。
                    <br />
                    （１）
                    採用・登録判断、合否判定等の社員、派遣登録の採用業務遂行のため
                    <br />
                    （２） 合否結果の通知・連絡等をおこなうため
                    <br />
                    （３） 入社に必要な手続きを行なう為
                  </Typography>
                  <Typography
                    variant="h4"
                    sx={{
                      paddingBottom: "0.4rem",
                      fontSize: "1.2rem",
                      fontWeight: "bold",
                    }}
                  >
                    4.個人情報提供における任意性
                  </Typography>
                  <Typography
                    sx={{
                      paddingBottom: "2.5rem",
                      fontSize: "1.1rem",
                      color: "#444343",
                    }}
                  >
                    当社に、個人情報をご提供頂けるか否かは応募者に委ねられます。ただし、ご提供頂けない場合、3.個人情報の利用目的の遂行に関して支障をきたす恐れがあります。
                  </Typography>
                  <Typography
                    variant="h4"
                    sx={{
                      paddingBottom: "0.4rem",
                      fontSize: "1.2rem",
                      fontWeight: "bold",
                    }}
                  >
                    5.個人情報の第三者への開示
                  </Typography>
                  <Typography
                    sx={{
                      paddingBottom: "2.5rem",
                      fontSize: "1.1rem",
                      color: "#444343",
                    }}
                  >
                    当社は、次に掲げる場合を除き、採用者の個人情報を第三者に提供することはありません。
                    <br />
                    （１）　法令に基づく場合
                    <br />
                    （２）　人の生命、身体又は財産の保護のために必要がある場合であって、本人の同意を得ることが困難な場合
                    <br />
                    （３）　国の機関若しくは地方公共団体又はその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、
                    本人の同意を得ることによって当該事務の遂行に支障を及ぼす恐れがある場合
                  </Typography>
                  <Typography
                    variant="h4"
                    sx={{
                      paddingBottom: "0.4rem",
                      fontSize: "1.2rem",
                      fontWeight: "bold",
                    }}
                  >
                    6.本人及び代理人からの開示等の申し込み
                  </Typography>
                  <Typography
                    sx={{
                      paddingBottom: "2.5rem",
                      fontSize: "1.1rem",
                      color: "#444343",
                    }}
                  >
                    本人又は代理人は、当社に対して個人情報の開示等（利用目的の通知、開示、内容の訂正･追加･削除、利用の停止または消去、第三者への提供の停止）に関して申し出ることができます。
                    その際、当社は本人確認の上、合理的な期間内に対応いたします。開示等の申し出の詳細については、当社個人情報保護管理責任者までご連絡下さい。
                  </Typography>
                  <Typography
                    variant="h4"
                    sx={{
                      paddingBottom: "0.4rem",
                      fontSize: "1.2rem",
                      fontWeight: "bold",
                    }}
                  >
                    7.不採用となられた方の個人情報・機微な個人情報について
                  </Typography>
                  <Typography
                    sx={{
                      paddingBottom: "2.5rem",
                      fontSize: "1.1rem",
                      color: "#444343",
                    }}
                  >
                    当社が責任をもって廃棄させていただきます。
                  </Typography>
                  <Typography
                    variant="h4"
                    sx={{
                      paddingBottom: "0.4rem",
                      fontSize: "1.2rem",
                      fontWeight: "bold",
                    }}
                  >
                    8.お問い合わせ窓口
                  </Typography>
                  <Typography
                    sx={{
                      paddingBottom: "2.5rem",
                      fontSize: "1.1rem",
                      color: "#444343",
                    }}
                  >
                    苦情相談等には、下記を窓口として速やかに対応致します。
                    <br />
                    個人情報保護担当窓口 MAIL：info@freeks.biz
                  </Typography>
                </Box>
              </Box>
              <Box textAlign="center" sx={{ margin: "1rem auto 4rem" }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      name="privacy_check"
                      color="primary"
                      checked={agree}
                      onChange={(e) => setAgree(e.target.checked)}
                    />
                  }
                  label={
                    <Typography sx={{ fontSize: { xs: "1rem", sm: "1.2rem" } }}>
                      同意します。
                    </Typography>
                  }
                />
                {errors.agree && (
                  <Typography color="error" sx={{ fontSize: "0.9rem" }}>
                    {errors.agree}
                  </Typography>
                )}
              </Box>
            </form>
          </Box>
        </Box>
        <JsonContext.Provider value={{ jsonData, addValueToJson }}>
          <Box hidden={!isSelect}>
            {progressIndex === 1 && (
              <ExampleTestPart1 ref={childButtonClickRef} />
            )}
            {progressIndex === 2 && (
              <TestPart1
                ref={childButtonClickRef}
                nextPage={nextPage}
                testData1={testData1}
              />
            )}
            {progressIndex === 3 && (
              <ExampleTestPart2 ref={childButtonClickRef} />
            )}
            {progressIndex === 4 && (
              <TestPart2
                ref={childButtonClickRef}
                nextPage={nextPage}
                testData2={testData2}
              />
            )}
            {progressIndex === 5 && (
              <ExampleTestPart3 ref={childButtonClickRef} />
            )}
            {progressIndex === 6 && (
              <TestPart3
                ref={childButtonClickRef}
                nextPage={nextPage}
                testData3={testData3}
              />
            )}
            {progressIndex === 7 && (
              <ThanksPage ref={childButtonClickRef} nextPage={nextPage} />
            )}
            {progressIndex === 8 && (window.location.href = "/")}
          </Box>
        </JsonContext.Provider>
        <Box
          textAlign="center"
          sx={{
            margin: { xs: "0 auto 3rem", sm: "0 auto 6rem" },
            width: { xs: "90%", sm: "50%" },
          }}
        >
          <Button
            variant="contained"
            color="primary"
            fullWidth
            type="submit"
            disabled={isButtonDisabled || questionLoadError || isMaintenance}
            sx={{
              height: { xs: "4rem", sm: "6rem" },
              fontSize: { xs: "1.2rem", sm: "2rem" },
              fontWeight: "bold",
              letterSpacing: "0.3rem",

              ...(isMaintenance && {
                backgroundColor: "#9e9e9e",
                color: "#fff",
                cursor: "not-allowed",
                "&:hover": {
                  backgroundColor: "#9e9e9e",
                },
              }),
            }}
            onClick={async (e) => {
              if (isMaintenance) return;

              setApiError("");
              // ローディング状態を設定
              setLoading(true);
              // 進行インデックスが0の場合はhandleSubmitを実行
              if (progressIndex === 0) {
                const isSuccess = await handleSubmit(e);
                if (isSuccess) {
                  nextOnClick();
                }
              } else {
                nextOnClick();
              }
            }}
          >
            {isMaintenance
              ? "メンテナンス中"
              : loading
              ? "読み込み中..."
              : progressIndex === 1
              ? "開始"
              : progressIndex === 2
              ? "解答を終える"
              : progressIndex === 3
              ? "開始"
              : progressIndex === 4
              ? "解答を終える"
              : progressIndex === 5
              ? "開始"
              : progressIndex === 6
              ? "解答を終える"
              : progressIndex === 7
              ? "トップページへ戻る"
              : "試験を開始する"
            }
          </Button>
          {questionLoadError && (
            <Typography color="error" sx={{ mt: 2 }}>
              問題の取得に失敗しました。ページを再読み込みして再度お試しください。
            </Typography>
          )}
          {apiError && (
            <Typography color="error" sx={{ fontSize: 15, mt: 2, whiteSpace: "pre-line" }}>
              {apiError}
            </Typography>
          )}
        </Box>
      </Paper>
    </Container>
  );
}

// 子コンポーネントで使用するためのカスタムフック
export const useJsonContext = () => useContext(JsonContext);

export default AptitudeTest;
